import { getNestedProperty } from '@opallabs/lambda'

export const getJsonApiUsers = (state) =>
  state.jsonApiEntities && state.jsonApiEntities.users
export const getMe = (state) => state && state.me

export const getUser = (state, id) => {
  const users = getNestedProperty(state, 'jsonApiEntities', 'users')
  if (users !== undefined) {
    return users[id]
  }
  return undefined
}
